<script setup lang="ts">
import { useAttrs, ref, onMounted } from 'vue'
import { SpinePlayer } from '@esotericsoftware/spine-player'

const props = withDefaults(
  defineProps<{
    name: string
    animation: string
    endDelay?: number
    timeScale?: number
    loop?: boolean
  }>(),
  {
    endDelay: 0
  }
)

const emit = defineEmits(['done'])

const attrs = useAttrs()
onMounted(() => {
  const player = new SpinePlayer(target.value!, {
    jsonUrl: `/assets/spine/${props.name}/${props.name}.json`,
    atlasUrl: `/assets/spine/${props.name}/${props.name}.atlas`,
    preserveDrawingBuffer: true,
    showControls: false,
    showLoading: false,
    premultipliedAlpha: false,

    alpha: true,
    backgroundColor: '#00000000',
    ...attrs,
    success() {
      player.addAnimation(props.animation, props.loop)
      player.play()
      if (player.animationState) {
        player.animationState.timeScale = props.timeScale ?? 1
        player.animationState?.addListener({
          complete: () => {
            setTimeout(() => {
              emit('done')
              player.stopRendering()
            }, props.endDelay)
            setTimeout(() => {
              player.dispose()
            }, 5000)
          }
        })
      }
    }
  })
})

const target = ref<HTMLElement | null>(null)
</script>
<template>
  <div ref="target" />
</template>
